import React from "react";
import PepiteInfos from "./PepiteInfos/PepiteInfos";
import PartnersModal from "../../../containers/Modals/PartnersModal";
import PropTypes from "prop-types";
import Card from "../../../containers/Card/Card";
import contactCareManager1 from "../../../assets/img/contactCareManager.svg";
import contactCareManager2 from "../../../assets/img/offerModal/offre-1.png";
import demand from "../../../assets/icons/contact.svg";
import imgIntroMobile from "../../../assets/img/offerModal/offre-3.png";
import reception from "../assets/img/introReception.svg";
import offre2 from "../../../assets/img/offerModal/offre-2.png";
import qualiteprestations from "../../../assets/img/qualiteprestations.svg";
import {useHistory} from "react-router-dom";
import Banniere from "../../Banniere/Banniere";

const Accueil = ({
																	dataUser,
																	pagePerso,
																	setIframe,
																	iframe,
																	listCases,
																	page,
																	handleOpenNavItem,
																	idExt,
																	isSouscription,
																	setShowOfferModal,
																	navItem,
																	setPagePerso,
																	}) => {
const history = useHistory();
const handlePlanDemand = () => {
console.log("idext", idExt);
console.log("souscription", isSouscription);
if (idExt === "B2C" && isSouscription === undefined) {
console.log("souscription pas encore défini");

} else if (idExt === "B2C" && !isSouscription) {
// Si le user est un client B2C et qu'il n'a pas de souscriptions
// on ouvre la modal des offres payantes
setShowOfferModal(true);
console.log("openoffermodal");
} else if (idExt === "BPCE-B2C") {
setShowOfferModal(true);
} else if (idExt === "B2C" && isSouscription) {
// Si c'est un client B2C et qu'il a une souscriptions
// on le redirige vers le bot de demande de rendez-vous
history.push("/conversation");
} else if (idExt !== "B2C") {
// Si le user à un idExt différent de B2C, c'est qu'il a entré un code d'activation
// et qu'il est rattaché à une entreprise (client B2B)
history.push("/conversation");
console.log("il y a un idext mais diff de b2c");
} else {
console.log("pas d'idext");
setShowOfferModal(true);
}
};
const stepsItems = [
{
number: 1,
src: contactCareManager2,
title: "Evaluation",
content: "de la situation du proche et de son aidant"
},
{
number: 2,
src: reception,
title: "Réception",
content: "du plan d’aide personnalisé en 24 heures"
},
{
number: 3,
src: offre2,
title: "Mise en place",
content: "des aides financières et des prestataires"
},
{
number: 4,
src: qualiteprestations,
title: "Suivi",
content: "de la qualité des prestations"
}
];
return (
<>
<Banniere dataUser={dataUser}/>
<PartnersModal
pagePerso={pagePerso}
setIframe={setIframe}
iframe={iframe}
setPagePerso={setPagePerso}
/>

<ul className={"list-cases mobile-list-container"} id={"listCases-noCases"}>
{(listCases.length !== 0)
?
<Card navItem={navItem}/>
:
<li
className={"contactManager"}
id={"contactManagerBlock"}
onClick={handlePlanDemand}
>
<img src={demand} className={"icone"} alt={"icone-contact"}/>
<p className={"contact-text"}>Contactez<br/>votre</p>
<p className={"cm-text"}>Care Manager<br/>ici</p>
<img className={"img"} alt={"img"} src={contactCareManager1}/>
</li>
}
<ul id={"intro-block-mobile"} className={"horizontal-scroll mobile-list-container-ul"}>
<li className={"mobile-list-container-ul-li"}>
<img src={imgIntroMobile}/>
<p className={"titre"}>Comment nous vous aidons ?</p>
<p>Nous vous conseillons, et prenons en charge toute l’organisation du parcours
de
soins de votre proche.</p>
</li>
{stepsItems.map((item) => {
return (
<li className={"mobile-list-container-ul-li"} key={item.number}>
<img src={item.src}/>
<div className={"line"}><p>{item.number}</p></div>
<p>
<strong style={{fontWeight: "300"}}>{item.title}</strong>
<br/>{item.content}</p>

</li>
);
})}
</ul>
</ul>
<PepiteInfos
page={page}
handleOpenNavItem={handleOpenNavItem}
dataUser={dataUser}
/>
</>
);
};

Accueil.propTypes = {
dataUser: PropTypes.object,
pagePerso: PropTypes.bool,
setIframe: PropTypes.func,
iframe: PropTypes.bool,
listCases: PropTypes.array,
page: PropTypes.string,
handleOpenNavItem: PropTypes.func,
idExt: PropTypes.string,
isSouscription: PropTypes.func,
setShowOfferModal: PropTypes.func,
navItem: PropTypes.object,
setPagePerso: PropTypes.func,
};

export default Accueil;